import { Dropdown } from 'antd';
import { BCMenu } from '..';
import { IDropdownWrapperProps } from './entities';
import React from 'react';

import classNames from 'classnames/bind';

const BCDropdownWrapper = (props: IDropdownWrapperProps) => {
	const [open, setOpen] = React.useState<boolean>(false);

	const getMenuProps = () => {
		const items = props.menuProps.items.map(item => ({
			...item,
			className: ['ant-menu-item ant-menu-item-only-child', item.className]
				.filter(Boolean)
				.join(' ')
		}));

		return BCMenu({
			...props.menuProps,
			onClick: args => {
				setOpen(false);
				props.menuProps?.onClick?.(args);
			},
			className: ['ant-menu ant-menu-root ant-menu-vertical', props.menuProps.className]
				.filter(Boolean)
				.join(' '),
			items,
			getOnlyMenuProps: true
		});
	};

	const onOpenChange = (open: boolean) => {
		setOpen(open);
		props.onOpenChange?.(open);
	};

	return (
		<div
			onClick={e => props.stopPropagation && e.stopPropagation()}
			data-selenium-id={props.seleniumId}
			className={classNames({ [props.containerClassName]: !!props.containerClassName, open })}
		>
			<Dropdown
				menu={getMenuProps()}
				trigger={props.trigger}
				placement={props.placement}
				overlayClassName={props.overlayClassName}
				disabled={props.disabled}
				onOpenChange={onOpenChange}
				destroyPopupOnHide={props.destroyPopupOnHide}
			>
				{props.children}
			</Dropdown>
		</div>
	);
};

export default BCDropdownWrapper;
export { IDropdownWrapperProps };
